"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerchantAuthType = exports.NiftronKeypair = exports.Base64String = exports.UserAuthType = exports.UserType = exports.SignerStatus = exports.TokenRealm = exports.TokenCategory = exports.TokenType = void 0;

var stellar_sdk_1 = require("stellar-sdk");
/**
 * Token Type Interface
 */


var TokenType;

(function (TokenType) {
  TokenType["NFT"] = "NFT";
  TokenType["SFT"] = "SFT";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
/**
 * Token Category Interface
 */


var TokenCategory;

(function (TokenCategory) {
  TokenCategory["CERTIFICATE"] = "CERTIFICATE";
  TokenCategory["BADGE"] = "BADGE";
  TokenCategory["DIGITALART"] = "DIGITALART";
  TokenCategory["TICKET"] = "TICKET";
  TokenCategory["GIFTCARD"] = "GIFTCARD";
})(TokenCategory = exports.TokenCategory || (exports.TokenCategory = {}));
/**
 * Token Realm Interface
 */


var TokenRealm;

(function (TokenRealm) {
  TokenRealm["DIGITAL"] = "DIGITAL";
  TokenRealm["PHYSICAL"] = "PHYSICAL";
})(TokenRealm = exports.TokenRealm || (exports.TokenRealm = {}));
/**
 * SignerStatus Interface
 */


var SignerStatus;

(function (SignerStatus) {
  SignerStatus["PENDING"] = "PENDING";
  SignerStatus["ACCEPTED"] = "ACCEPTED";
  SignerStatus["REJECTED"] = "REJECTED";
})(SignerStatus = exports.SignerStatus || (exports.SignerStatus = {})); // /**
//  * NiftronCredential Interface
//  */
// export class NiftronCredential extends File {}

/**
 * User Type Interface
 */


var UserType;

(function (UserType) {
  UserType["CREATOR"] = "0";
  UserType["COLLECTOR"] = "1";
})(UserType = exports.UserType || (exports.UserType = {}));
/**
 * User Auth Type Interface
 */


var UserAuthType;

(function (UserAuthType) {
  UserAuthType["LOWPRIVACY"] = "0";
  UserAuthType["MEDIUMPRIVACY"] = "1";
  UserAuthType["HIGHPRIVACY"] = "2";
})(UserAuthType = exports.UserAuthType || (exports.UserAuthType = {}));
/**
 * Niftron Base64String for Images
 */


var Base64String =
/** @class */
function (_super) {
  __extends(Base64String, _super);

  function Base64String() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return Base64String;
}(String);

exports.Base64String = Base64String; // /**
//  * Niftron Keypair
//  */
// export interface NiftronKeypair extends Keypair {}

/**
 * Niftron Keypair
 */

var NiftronKeypair =
/** @class */
function (_super) {
  __extends(NiftronKeypair, _super);

  function NiftronKeypair() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return NiftronKeypair;
}(stellar_sdk_1.Keypair);

exports.NiftronKeypair = NiftronKeypair;
/**
 * Merchant Auth Type
 */

var MerchantAuthType;

(function (MerchantAuthType) {
  MerchantAuthType["REGULAR"] = "0";
  MerchantAuthType["ZEROFAILURE"] = "1";
})(MerchantAuthType = exports.MerchantAuthType || (exports.MerchantAuthType = {}));